<template>
  <div id="app">
    <router-view />
    <!--  去往交税  -->
    <van-popup v-model="payTaxShow" class="commonPopup popup" @close="closePayTax">
      <div class="popupClose" @click="payTaxShow = false;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18" style="color: #55e129"></path><path d="m6 6 12 12" style="color: #55e129"></path></svg></div>
      <h4 class="popupTitle">Informação Importante</h4>
      <div class="popupCentent">
        <p>Para garantir a conformidade com as políticas financeiras, saques de alto valor requerem o pagamento de impostos aplicáveis.</p>
        <p>O processo é automático e transparente.</p>
      </div>
      <div class="popupBtn">
        <button @click="$router.push({path: '/iof'}); payTaxShow = false;">Pagar imposto</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { GetUserInfo } from "@/api/Perfil";
export default {
  name: "App",
  data () {
    return {
      taxCashBoolean: true,
      taxCashTimer: null,
      payTaxShow: false,
    }
  },
  created() {
    setInterval(() => {
      if (this.$store.state.userInfo.token) {
        GetUserInfo().then(res => {
          if (this.$route.path !== '/Scratch') {
            this.$store.commit('SETCASH', res);
            this.$store.commit('SETWITHDRAWAMOUNT', { payInTotal: res.payInTotal, payOutTotal: res.payOutTotal });
            this.$store.commit('SETREGISTERCASH', res.registerCash);
            this.$store.commit('SETTAXCASH', res.taxCash);
            this.$store.commit('SETPAYOUTLIST', res.payOutList);
          }
          this.$store.commit('SETSPININFO', {spinLimit: res.spinLimit, spinTotal: res.spinTotal});
          if (this.taxCashBoolean && res.taxCash > 0 && this.$route.path !== '/iof' && this.$route.path !== '/TAXAIOF' && this.$route.path !== '/qrcode') {
            this.payTaxShow = true;
          }
        });
      }
    }, 2000);
  },
  methods: {
    closePayTax () {
      this.taxCashBoolean = false;
      this.taxCashTimer = setTimeout(() => {
        this.taxCashBoolean = true;
      }, 1000 * 20);
    }
  }
}
</script>

<style scoped lang="scss">
.popup {
  width: 80%;
  .popupClose {
    position: absolute; right: 1rem; top: .8rem;
    svg { width: 1.231rem; height: 1.231rem;}
  }
  .popupTitle { font-weight: 500; font-size: .96rem; text-align: center; padding: .8rem 0;}
  .popupCentent {
    font-size: .96rem; margin: 0 1rem;
    p { margin-bottom: .6rem;}
    p:last-child { margin-bottom: 0;}
  }
  .popupBtn {
    display: flex; padding: 1rem;
    button { font-size: .96rem; flex: 1; background: #55e129; border: none; border-radius: .5rem; padding: .4rem 0;}
    button:not(:first-child) { margin-left: .4rem;}
  }
}
</style>
